import {Component, ElementRef, input, model, OnInit, output} from '@angular/core';

@Component({
  selector: 'app-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss']
})
export class AccordionItemComponent  implements OnInit {

  disabled = input<boolean>();
  expanded = model<boolean>();
  expandedChange = output<boolean>();

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {}

  toggle(): void {

    if (this.disabled()) {
      return;
    }
    this.expanded.set(!this.expanded());
    this.expandedChange.emit(this.expanded());
  }

}
